import { ProgressBarItemSingleModified } from 'components/ProgressBar/context';

import useProgressBarMultiSubstep from './useProgressBarItemMultiSubstep';

export interface ProgressBarItemMultiSubstepProps
  extends ProgressBarItemSingleModified {
  finalMainStep: boolean;
}

const ProgressBarItemMultiSubstep: React.FunctionComponent<ProgressBarItemMultiSubstepProps> =
  function (props) {
    const {
      first,
      last,
      finalMainStep,
      title,
      trackClassName,
      labelClassName,
    } = useProgressBarMultiSubstep(props);

    return (
      <>
        {!first ? (
          <div className="h-[2px] min-h-[2px] w-8 bg-neutral-300" />
        ) : (
          <div className="h-[6px] min-h-[6px] w-8 bg-neutral-300" />
        )}
        <div className="flex flex-row gap-x-7">
          <div className="flex flex-col">
            <div className={trackClassName}>
              <div className={labelClassName} />
            </div>
            {!(last && finalMainStep) && (
              <div className="flex-[1_1_0] bg-neutral-300" />
            )}
          </div>
          <div>
            <p className="text-14-22-em">{title}</p>
          </div>
        </div>
        {!last && <div className="h-[2px] min-h-[2px] w-8 bg-neutral-300" />}
        {!(last && finalMainStep) && (
          <div className="h-[6px] min-h-[6px] w-8 bg-neutral-300" />
        )}
      </>
    );
  };

export default ProgressBarItemMultiSubstep;
